<template>
  <div
    class="department"
    v-if="universityId && activecode && departmentdata.departmentId"
  >
    <!-- {{universityId}} <br> 
      {{departmentdata.departmentId}}<br> 
      {{activecode}}<br>  -->
    <h2>{{ departmentdata.departmentName }}</h2>
    <div class="chatarea">
      <div
        class="theoryechart chart"
        ref="theoryechart"
        v-if="isShowTheory"
      ></div>
      <!-- 灭火统计 -->
      <div class="outfireechart chart" ref="operechart"></div>
      <div
        class="outfireechart chart"
        ref="outfireechart"
        v-if="isShowOutfire"
      ></div>
    </div>
    <a-modal
      title="编辑图表数据"
      :visible="showmodal"
      @ok="sureedit"
      @cancel="canceledit"
      width="800px"
    >
      <div
        ref="jsoneditoren"
        :style="{ height: 500 + 'px', width: '100%' }"
      ></div>
    </a-modal>
  </div>
</template>

<script>
import Axios from "@/Axios";
// import JsonEditor from 'jsoneditor'
// import 'jsoneditor/dist/jsoneditor.min.css'
export default {
  //   components:{},
  name: "depart",
  props: {
    universityId: String,
    activecode: String,
    departmentdata: Object,
  },
  data() {
    return {
      isShowTheory: true,
      isShowOutfire: false,
      showmodal: false,
      editor: null,
      editmodo: null,
      outfiredata: [],
      bindata: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    //   获取部门信息
    getddepartdata() {
      let that = this;
      if (
        !this.departmentdata.departmentId ||
        !this.activecode ||
        !this.universityId
      ) {
        // console.log('+++++++')
        return;
      }
      Axios.get("/repcomposer/repComposer/report", {
        params: {
          activeCode: this.activecode,
          departmentId: this.departmentdata.departmentId,
          universityId: this.universityId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var records = res.data.result.records;
          this.reportdata = res.data.result.records;
          var newlist = records.map((item, index) => {
            var data = item.visualData || item.originalData;
            data = JSON.parse(data);
            // 理论统计
            if (item.step == "3") {
              if (data.length == 0) {
                this.isShowTheory = false
                return
              }
              that.drawbin(
                that.$refs.theoryechart,
                that.bindatahandle(that.formattheorydata(data)),
                "理论成绩分析"
              );
            }
             // 灭火统计
            if (item.step == 5) {
              that.draw(
                that.$refs.operechart,
                "灭火统计",
                that.operedatahandle(data)
              );
            }
            //灭火动作统计
            if (item.step == "6") {
              if (data.length == 0) {
                this.isShowOutfire = true
              }
              data = that.formatdata(data);
              that.drawbar(
                that.$refs.outfireechart,
                that.baroutfiredatahandle(data)[0],
                that.baroutfiredatahandle(data)[1],
                "灭火动作统计",
                "动作"
              );
            }
          });
        }
      });
    },
    // 灭火统计饼图
    draw(dom, bintitle, data) {
      // console.log(dom);
      var mychart = this.$echarts.init(dom);
      mychart.setOption({
        baseOption: {
          color:['gray','green','blue','red','#87cefa','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
          title: {
            text: bintitle,
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
          },
          legend: {
            // orient: 'vertical',
            // top: 'middle',
            bottom: 10,
            left: "center",
            selectedMode: false, //取消图例上的点击事件
          },
          series: [
            {
              type: "pie",
              radius: "65%",
              center: ["50%", "50%"],
              selectedMode: "single",
              data: data,

              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: "{b} : {c} ({d}%)",
                  },
                  lableLine: { show: true },
                },
              },
            },
          ],
        },
        media: [
          {
            query: {
              maxWidth: 500,
            },
            option: {
              color:['gray','green','blue','red','#87cefa','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
              title: {
                text: bintitle,
                left: "center",
              },
              tooltip: {
                trigger: "item",
                formatter: "{b} : {c} ({d}%)",
              },
              legend: {
                // orient: 'vertical',
                // top: 'middle',
                bottom: 10,
                left: "center",
                selectedMode: false, //取消图例上的点击事件
              },
              series: [
                {
                  type: "pie",
                  radius: "25%",
                  center: ["50%", "50%"],
                  selectedMode: "single",
                  data: data,

                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                  itemStyle: {
                    normal: {
                      label: {
                        show: true,
                        formatter: "{b} : {c} ({d}%)",
                      },
                      lableLine: { show: true },
                    },
                  },
                },
              ],
            },
          },
        ],
      });
    },
    // 饼图
    drawbin(dom, data, bintitle) {
      var mychart = this.$echarts.init(dom);
      mychart.clear();
      mychart.setOption({
        baseOption: {
          color:['gray','green','blue','red','#87cefa','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
          title: {
            text: bintitle,
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
          },
          legend: {
            // orient: 'vertical',
            // top: 'middle',
            bottom: 10,
            left: "center",
            selectedMode: false, //取消图例上的点击事件
          },
          series: [
            {
              type: "pie",
              radius: "65%",
              center: ["50%", "50%"],
              selectedMode: "single",
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: "{b} : {c} ({d}%)",
                  },
                  lableLine: { show: true },
                },
              },
            },
          ],
        },
        media: [
          {
            query: {
              maxWidth: 500,
            },
            option: {
              color:['gray','green','blue','red','#87cefa','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
              title: {
                text: bintitle,
                left: "center",
              },
              tooltip: {
                trigger: "item",
                formatter: "{b} : {c} ({d}%)",
              },
              legend: {
                // orient: 'vertical',
                // top: 'middle',
                bottom: 10,
                left: "center",
                selectedMode: false, //取消图例上的点击事件
              },
              series: [
                {
                  type: "pie",
                  radius: "25%",
                  center: ["50%", "50%"],
                  selectedMode: "single",
                  data: data,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                  itemStyle: {
                    normal: {
                      label: {
                        show: true,
                        formatter: "{b} : {c} ({d}%)",
                      },
                      lableLine: { show: true },
                    },
                  },
                },
              ],
            },
          },
        ],
      });
    },
    // 灭火统计数据处理
    operedatahandle(data) {
      if (data[0].rateMap) {
        delete data[0].rateMap
      }
      var arr = [];
      for (var key in data[0]) {
        var obj = {};
        obj.value = data[0][key];
        obj.name = key;
        arr.push(obj);
      }
      return arr;
    },
    // 其他饼图数据处理
    bindatahandle(data) {
      this.bindata = data;
      // console.log('666666666',data)
      var arr = [];
      data.map((item) => {
        var obj = {
          value: item.人数,
          name: item.评价,
        };
        arr.push(obj);
      });
      return arr;
    },
    // 柱状图
    drawbar(dom, xdata, ydata, title, xName) {
      // console.log(xdata, ydata, title);
      var mychart = this.$echarts.init(dom);
      mychart.clear();
      mychart.setOption({
        title: {
          text: title,
          left: "50%",
          textAlign: "center",
        },
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: "{b}<br/>{a}:{c}%",
        },
        grid: {
          left: "8%",
          right: "8%",
          bottom: "3%",
          containLabel: true,
        },
        yAxis: [
          {
            type: "value",
            name: "合格率%",
            // yAxis.nameTextStyle. verticalAlign
          },
        ],
        xAxis: [
          {
            type: "category",
            name: xName,
            // nameLocation:'start',
            data: xdata,
            axisLabel: {
              interval: 0,
              rotate: 50,
            },
            // nameRotate:"90",
            // axisLabel:{
            // formatter:function(value){
            //       return value.split("").join("\n");
            // }
            // },
            nameGap: 0,
            axisTick: {
              alignWithLabel: true,
            },
            // nameLocation: "center",
            // nameTextStyle. fontWeight
          },
        ],
        series: [
          {
            name: "合格率",
            type: "bar",
            // formatter: "{a}：{c}",
            barWidth: "30%",
            data: ydata,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  // rotate:90,
                  // align:'left',
                  // verticalAlign:'middle',
                  // position: "insideBottom",
                  formatter: "{c}%",
                  position: "top",
                  textStyle: {
                    color: "red ",
                    fontWeight: "blod",
                    fontSize: "20px",
                  },
                },
              },
            },
          },
        ],
      });
    },
    // 灭火动作柱状图数据处理
    baroutfiredatahandle(data) {
      this.outfiredata = data;
      // console.log('this.outfiredata',this.outfiredata)
      var xdata = [];
      var ydata = [];
      xdata.push();
      data.map((item) => {
        xdata.push(item.项目名称);
        var per = (
          (item.正确人数 / (item.正确人数 + item.错误人数)) *
          100
        ).toFixed(1);
        ydata.push(per);
      });
      return [xdata, ydata];
    },
    // editdata(model) {
    //   var data = null;
    //   this.editmodo = model;
    //   this.showmodal = true;
    //   if (model == "bin") {
    //     data = this.bindata;
    //   }
    //   if (model == "bar") {
    //     data = this.outfiredata;
    //   }
    //   setTimeout(() => {
    //     this.initjsoneditor(data);
    //   }, 500);
    // },
    // 初始化编辑数据共计
    // initjsoneditor(data){
    //     let container = this.$refs.jsoneditoren;
    //     console.log("container",container)
    //     let options = {
    //       modes: ['text', 'code', 'tree', 'form', 'view'],
    //       mode: 'code',
    //       // ace: ace,
    //       sortObjectKeys: 'code',
    //       mainMenuBar:['format']
    //     };
    //     this.$refs.jsoneditoren.innerHTML = ''
    //     this.editor = new JsonEditor(container, options);
    //     this.editor.set(data)
    // },
    sureedit() {
      let text = this.editor.getText();
      let that = this;
      if (!text || text.length <= 0 || text == "{}" || text == "[]") {
        this.$message.warning("未录入任何信息");
        return;
      } else {
        text = JSON.parse(text);
      }
      this.canceledit();
      if (this.editmodo == "bin") {
        that.drawbin(
          that.$refs.theoryechart,
          that.bindatahandle(text),
          "理论成绩分析"
        );
      }
      if (this.editmodo == "bar") {
        that.drawbar(
          that.$refs.outfireechart,
          that.baroutfiredatahandle(text)[0],
          that.baroutfiredatahandle(text)[1],
          "灭火动作统计",
          "动作"
        );
      }
    },
    canceledit() {
      this.showmodal = false;
    },
    // 灭火动作数据格式转换
    formatdata(data) {
      var arr = [];
      data.map((item) => {
        var obj = {
          正确人数: item.ACount,
          错误人数: item.BCount,
          项目名称: item._id,
        };
        arr.push(obj);
      });
      return arr;
    },
    // 理论数据格式转换
    formattheorydata(data) {
      if (data[0].rateMap) {
        delete data[0].rateMap
      }
      // console.log('44445', data[0])
      var arr = [];
      for (var key in data[0]) {
        var obj = {
          人数: data[0][key],
          评价: key,
        };
        arr.push(obj);
      }
      return arr;
    },
  },
  created() {},
  mounted() {
    //   console.log(this.departmentdata)
    this.getddepartdata();
  },
};
</script>
<style scoped>
@media screen and (min-width: 768px) {
  .chatarea {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}
@media screen and (max-width: 768px) {
  .chatarea {
    display: flex;
    flex-direction: column;
    margin: 20px auto;
    border-bottom: 1px solid #dbdbdb;
  }
}
@media screen and (min-width: 768px) {
  .department {
    width: 100%;
    height: 600px;
    box-sizing: border-box;
    padding: 30px 0 70px 0;
    margin: 0 auto;
    /* margin-bottom: 50px; */
    border-top: 1px solid #dbdbdb;
  }
}
@media screen and (min-width: 768px) {
  .chart {
    height: 500px;
    width: 50%;
  }
}
@media screen and (max-width: 768px) {
  .chart {
    height: 300px;
    width: 90%;
    margin: 35px auto;
  }
}
h2 {
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/chartpage/components/departmentdata.vue